var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_vm._v(" Need Help? Email "),_c('a',{staticClass:"primary-link-light",attrs:{"href":"mailto:sales@paragonintel.com"}},[_vm._v("sales@paragonintel.com")]),(_vm.hasSalesContact)?_c('span',[_vm._v(" or call "+_vm._s(_vm.salesContact.name)+" at "+_vm._s(_vm.salesContact.phoneNumber)+" ")]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }